<template>
        <div class="staff">
            <div class="left-top">
                <span style="font-size: 18px; font-weight: 400; color: #333">最新活动设置</span>
                <el-divider></el-divider>
            </div>

            <el-form ref="formRef" :model="formData" :rules="rules" label-width="110px">
                <el-form-item label="活动链接" prop="link">
                    <el-input style="width: 400px"
                        v-model.trim="formData.link"
                        placeholder="请输入最新活动链接"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
                        确定
                    </el-button>
                </el-form-item>
            </el-form>
    </div>
</template>
<script>
    export default {
        name: "NewActivity",
        data() {
            return {
                            submitLoading: false,
                            formData: {
                                link: "",
                            },
                            rules: {
                                link: [
                                    { required: true, message: "请输入活动链接", trigger: "blur" }
                                ]
                            }
            }
        },
         mounted() {
            this.getActivityLink();
        },
        methods: {
            getActivityLink() {
                this.$get(this.$api.GetNewestActivityLink)
                    .then((res) => {
                            if (res && res.IsSuccess) {
                            this.formData.link =  data.Message
                            }
                    })
                    .catch(() => {
                        this.$message({
                            type: "warning",
                            message: "获取活动链接失败",
                            duration: 1200,
                        });
                    });
            },
            handleSubmit() {
                this.$refs.formRef.validate((valid) => {
                    if (!valid) {
                        return;
                    }

                    this.submitLoading = true;
                    this.$post(this.$api.ConfigNewestActivityLink,null , { ...this.formData })
                        .then((res) => {
                            if (res && res.IsSuccess) {
                                this.$message({
                                    type: "success",
                                    message: "设置成功",
                                    duration: 1000,
                                });
                                return;
                            }

                            this.$message({
                                type: "warning",
                                message: (res && (res.PromptMsg || res.Message)) || "设置失败",
                                duration: 1200,
                            });
                        })
                        .catch(() => {
                            this.$message({
                                type: "error",
                                message: "请求失败，请稍后重试",
                                duration: 1200,
                            });
                        })
                        .finally(() => {
                            this.submitLoading = false;
                        });
                });
            }
        }
    }
</script>
<style scoped>
.staff {
  background: #fff;
  padding: 10px 10px;
  border-radius: 10px;
}

.left-top {
    margin-bottom: 10px;
}
</style>